import { render, staticRenderFns } from "./LabelAnswer.vue?vue&type=template&id=d67123d2&"
import script from "./LabelAnswer.vue?vue&type=script&lang=js&"
export * from "./LabelAnswer.vue?vue&type=script&lang=js&"
import style0 from "./LabelAnswer.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports